import MediatorManager from "../../../core/application/MediatorManager";
import SkinFactory from "../../../core/ui/SkinFactory";
import ChatMessage from "../model/ChatMessage";
import ChatMessageMediator from "../view/ChatMessageMediator";

export default class ChatMessageFactory {
    /**
     * @constructor
     * @param {MediatorManager} mediatorManager 
     */
    constructor(mediatorManager) {
        this._mediatorManager = mediatorManager;
    }

    /**
     * Creates a chat message mediator
     * @param {ChatMessage} chatMessage 
     * @param {Object} skinKeyRegistry The skin key registry to instantiate the item skin from (e.g. SmartphoneSkinKeyRegistry)
     * @returns {ChatMessageMediator}
     */
    create(chatMessage, skinKeyRegistry) {
        const skin = this._getSkinForMessage(chatMessage, skinKeyRegistry);
        skin.customData = {
            chatMessage
        };

        return this._mediatorManager.createMediator(skin, skinKeyRegistry.CHAT_MESSAGE_SKIN);
    }

    _getSkinForMessage(chatMessage, skinKeyRegistry) {
        if (chatMessage.fromPlayer) {
            return SkinFactory.getSkin(skinKeyRegistry.CHAT_PLAYER_MESSAGE);
        }

        if (chatMessage.npcId) {
            return SkinFactory.getSkin(skinKeyRegistry.CHAT_GROUP_MESSAGE);
        }

        return SkinFactory.getSkin(skinKeyRegistry.CHAT_OTHER_INDIVIDUAL_MESSAGE);
    }
}